// Zentrale Hilfsfunktion für Datums-/Zeitformatierung
// Nutzt i18n.language für konsistente Lokalisierung
import i18n from '../i18n';

export function formatDateTime(date, options = {}) {
  if (!date) return '';
  const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  // Default: Tag, Monat, Stunde, Minute
  const defaultOptions = { weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  return d.toLocaleString(i18n.language, { ...defaultOptions, ...options });
}

export function formatDate(date, options = {}) {
  if (!date) return '';
  const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  const defaultOptions = { year: 'numeric', month: 'short', day: 'numeric' };
  return d.toLocaleDateString(i18n.language, { ...defaultOptions, ...options });
}

export function formatTime(date, options = {}) {
  if (!date) return '';
  const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  const defaultOptions = { hour: '2-digit', minute: '2-digit' };
  return d.toLocaleTimeString(i18n.language, { ...defaultOptions, ...options });
}
